// extracted by mini-css-extract-plugin
export default {"options_parent":"SearchBar_options_parent__C4Zan","options_box":"SearchBar_options_box__dj7HG"};